import { useEffect, useState } from 'react';
import './company_header.css';
import { useCompany } from '../contexts/CompanyContext';
import { authFetch } from '../utils/api';
import { UrlDev } from '../url';

// Default dealer (id 1) is a placeholder for owner-class users; treat as "no dealer"
const DEFAULT_DEALER_ID = 1;

const CompanyHeader = ({ documentType = 'Quote', quoteData, companyName: propCompanyName, logoUrl: propLogoUrl, customer }) => {
  const { companyData: ownerCompany, logoUrl: ownerLogoUrl } = useCompany();
  const [dealerBranding, setDealerBranding] = useState(null);
  const [resolvedDealerId, setResolvedDealerId] = useState(null);

  // dealer_id may be present directly on the quoteData; otherwise look it up by quoteId
  const directDealerId = quoteData?.dealer_id;
  const quoteId = quoteData?.id || quoteData?.quoteId;

  useEffect(() => {
    let cancelled = false;
    if (directDealerId !== undefined && directDealerId !== null) {
      setResolvedDealerId(directDealerId);
      return;
    }
    if (!quoteId) {
      setResolvedDealerId(null);
      return;
    }
    authFetch(`/quotes/${quoteId}`)
      .then(q => { if (!cancelled) setResolvedDealerId(q?.dealer_id ?? null); })
      .catch(err => console.error('Failed to look up quote dealer', err));
    return () => { cancelled = true; };
  }, [directDealerId, quoteId]);

  const useDealerScope = resolvedDealerId && resolvedDealerId !== DEFAULT_DEALER_ID;

  useEffect(() => {
    if (!useDealerScope) {
      setDealerBranding(null);
      return;
    }

    let cancelled = false;
    authFetch(`/company/?dealer_id=${resolvedDealerId}`)
      .then(data => { if (!cancelled && data) setDealerBranding(data); })
      .catch(err => console.error('Failed to load dealer branding for quote header', err));
    return () => { cancelled = true; };
  }, [resolvedDealerId, useDealerScope]);

  // Choose effective branding source: quote's dealer (if applicable) or owner
  const effective = useDealerScope && dealerBranding ? dealerBranding : ownerCompany;

  const resolvedLogoUrl =
    useDealerScope && dealerBranding
      ? (dealerBranding.logo_path?.startsWith('/images/') ? UrlDev + dealerBranding.logo_path : dealerBranding.logo_path)
      : ownerLogoUrl;

  const displayCompanyName = propCompanyName || effective.name;
  const displayLogoUrl = propLogoUrl || resolvedLogoUrl;

  return (
    <div className="quote-header">
      <div className="company-logo">
        <img src={displayLogoUrl} alt="Company Logo" />
      </div>

      <div className="header-content">
        <p><strong>{documentType} #:</strong> {quoteData?.orderNumber || quoteData?.id || "N/A"}</p>
        <p><strong>Reference:</strong> {quoteData?.reference || "N/A"}</p>
        <p><strong>Date:</strong> {quoteData?.orderDate || "N/A"}</p>
        {customer && (
          <>
            <p><strong>Issued To:</strong> {customer.name}</p>
            {customer.address && <p>{customer.address}</p>}
            {customer.email && <p>{customer.email}</p>}
          </>
        )}
      </div>

      <div className="company-info">
        <p>{effective.details1}</p>
        <p>{effective.details2}</p>
        <p>{effective.details3}</p>
      </div>
    </div>
  );
};


export default CompanyHeader;
